import { IMonitorWithSecondlyNoiseConfig } from 'app/business-logic/domain-models/Monitoring';
import { useMemo } from 'react';

export const useMonitorsWithUniqueConfig = (secondlyNoiseMonitors: Array<IMonitorWithSecondlyNoiseConfig>) => {
  return useMemo(() => {
    const uniqueConfigurations: Array<IMonitorWithSecondlyNoiseConfig> = [];
    const duplicateConfigurations: Array<{
      monitor: IMonitorWithSecondlyNoiseConfig;
      firstInstance: IMonitorWithSecondlyNoiseConfig;
    }> = [];
    secondlyNoiseMonitors.forEach((monitor, index, arr) => {
      const firstIndexWithDeviceId = arr.findIndex(
        m => m.omnisConfigJson.config.deviceId === monitor.omnisConfigJson.config.deviceId
      );
      const firstInstance = arr[firstIndexWithDeviceId];
      if (!firstInstance) return;
      const isUnique = firstIndexWithDeviceId === index;
      if (isUnique) {
        uniqueConfigurations.push(monitor);
        return;
      }
      duplicateConfigurations.push({
        monitor,
        firstInstance,
      });
    });
    return {
      uniqueConfigurations,
      duplicateConfigurations,
    };
  }, [secondlyNoiseMonitors]);
};
